import { useMySettingsApi } from '../api';
import { Theme } from '../api/graphql/gql-authz/graphql';
import { THEME_ICONS, THEME_NAMES } from '../constants';
import { useSetThemeBothApiAndLocal } from './useSetThemeBothApiAndLocal';
import { useThemeData } from '@msrceng/theme';
/**
 * Returns the `ICommandBarItemProps` for a menu/button on a Fluent
 * CommandBar that lets you switch which theme the user has selected.
 *
 * > This handles whether the user is logged in or not by itself.
 */
export const useThemeCommandBarItem = ({ stringsThemeItem: { itemText = 'Theme', ThemeNameStrings = THEME_NAMES, } = {}, }) => {
    const { themeKey } = useThemeData();
    const { isLoading } = useMySettingsApi();
    const setTheme = useSetThemeBothApiAndLocal();
    return {
        key: 'theme',
        text: itemText,
        secondaryText: ThemeNameStrings[themeKey || 'AUTO'],
        iconProps: {
            iconName: 'Color',
        },
        disabled: isLoading,
        subMenuProps: {
            title: `Theme - ${ThemeNameStrings[themeKey || 'AUTO']}`,
            onItemClick: (e, item) => {
                var _a;
                if (!item) {
                    return;
                }
                (_a = e === null || e === void 0 ? void 0 : e.preventDefault) === null || _a === void 0 ? void 0 : _a.call(e);
                setTheme(item.key);
            },
            items: [
                {
                    key: Theme.Auto,
                    text: ThemeNameStrings.AUTO,
                    iconProps: { iconName: THEME_ICONS.AUTO },
                    checked: themeKey === 'AUTO',
                    disabled: isLoading,
                },
                {
                    key: Theme.Dark,
                    text: ThemeNameStrings.DARK,
                    iconProps: { iconName: THEME_ICONS.DARK },
                    checked: themeKey === 'DARK',
                    disabled: isLoading,
                },
                {
                    key: Theme.Light,
                    text: ThemeNameStrings.LIGHT,
                    iconProps: { iconName: THEME_ICONS.LIGHT },
                    checked: themeKey === 'LIGHT',
                    disabled: isLoading,
                },
            ],
        },
    };
};
